export default __webpack_public_path__ + "d13657108df96a78666b988869bf40ae.png";